/**
 * Named colours for states that had no token.
 *
 * These exist as TypeScript constants rather than Tailwind classes on purpose.
 * src/index.css is committed PRE-COMPILED Tailwind, so any class not already in
 * that bundle silently does nothing — which is exactly how the onboarding terms
 * checkbox ended up white: it asked for `data-[state=checked]:bg-green-500`, a
 * class the bundle does not contain, so the primitive's own
 * `data-[state=checked]:bg-primary` won instead. `--primary` is #f39c12 in one
 * theme and #030213 in the other, so the "agreed" state never looked agreed.
 *
 * An inline style always applies, whatever the stylesheet contains.
 */

/** Confirmed, accepted, agreed. Tailwind's green-500, which the app already reads as success. */
export const SUCCESS = '#22c55e';

/** Text and icons sitting on SUCCESS. */
export const ON_SUCCESS = '#ffffff';
